import { render, staticRenderFns } from "./BodoviComponent.vue?vue&type=template&id=3b343bdc&scoped=true&"
import script from "./BodoviComponent.vue?vue&type=script&lang=js&"
export * from "./BodoviComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b343bdc",
  null
  
)

export default component.exports